import { Send } from "lucide-react";
import { fmtDateTime } from "../lib/callback";

export const EmailHistory = ({ lead }) => {
  const log = [...(lead.email_log || [])].reverse();
  if (!log.length) return null;
  return (
    <div className="mt-3" data-testid={`lead-email-history-${lead.id}`}>
      <span className="font-mono text-[10px] uppercase tracking-widest text-slate-500 flex items-center gap-1 mb-1">
        <Send className="h-3 w-3" /> Emails sent ({log.length})
      </span>
      <ul className="space-y-1">
        {log.map((e, i) => (
          <li key={i} data-testid={`lead-email-history-item-${lead.id}-${i}`}
            className="text-xs bg-[#0B0C0E] border border-[#262C38] rounded px-2.5 py-1.5 flex flex-wrap justify-between gap-x-3">
            <span className="text-emerald-300">{e.label}</span>
            <span className="font-mono text-[10px] text-slate-500">{e.to} · {fmtDateTime(e.at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
